import { render, staticRenderFns } from "./maps.vue?vue&type=template&id=252afd09&scoped=true"
import script from "./maps.vue?vue&type=script&lang=js"
export * from "./maps.vue?vue&type=script&lang=js"
import style0 from "./maps.vue?vue&type=style&index=0&id=252afd09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252afd09",
  null
  
)

/* custom blocks */
import block0 from "./maps.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports